import React from 'react';

export default function HealthDocumentGallery({ documents, onRemove }) {
  if (!documents || documents.length === 0) return null;

  return (
    <div className="space-y-2 mt-6">
      <h3 className="text-lg font-bold">Uploaded Medical Documents</h3>
      <ul className="space-y-2">
        {documents.map((doc, index) => (
          <li key={index} className="flex items-center justify-between p-2 border rounded">
            <a
              href={doc.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline text-sm truncate max-w-xs"
            >
              View Document
            </a>
            <button
              onClick={() => onRemove(index)}
              className="bg-red-500 text-white rounded-full px-2 py-1 text-xs hover:bg-red-600"
            >
              ✖
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}